exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/widget/abstract-form-widget/abstract-form-widget.component.css
// module id = ../../../../../src/app/shared/components/widget/abstract-form-widget/abstract-form-widget.component.css
// module chunks = main